<template>
	<div id="playlists">
		<div class="tag" v-for="playlist in playlists" v-bind:key="playlist.id" @click="selectPlaylist(playlist)">
			{{ playlist.title }}
			<span>{{ songsCountInPlaylists[playlist.id] }}</span>
		</div>
		<div class="tag" @click="createPlaylist">
			<IconPlus /> {{ $t('song.createPlaylistButton') }}
		</div>
	</div>
</template>

<script>
	import IconPlus from "@/components/icons/IconPlus";
	import { mapState } from "vuex";
	import { RefreshSongsEventMixin } from "@/mixins/RefreshSongsEventMixin";

	export default {
		components: {
			IconPlus
		},
		mixins: [
			RefreshSongsEventMixin
		],
		computed: {
			...mapState([ "playlists", "playlistsSongs" ])
		},
		recomputed: {
			songsCountInPlaylists() {
				var counts = {};
				Object.keys(this.playlistsSongs).map(key => {
					counts[key] = this.playlistsSongs[key].length;
				});
				return counts;
			}
		},
		methods: {
			selectPlaylist(playlist) {
				this.$store.commit("setSongsFilter", {
					playlist: playlist.id,
					author: null,
					onlyQueue: false
				});
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
			},
			createPlaylist() {
				this.$modal.show("create-playlist");
			},
			refreshSongs() {
				this.$recompute("songsCountInPlaylists");
			},
		},
	}

</script>

<style lang="scss" scoped>
	#playlists {
		padding-bottom: 20px;

		.tag {
			.icon-plus {
				float: left;
				margin: 3px 10px 0 0;
			}
		}
	}
</style>
